import React, { Component, createRef } from "react";
import { Button, Card, Header, Input } from "semantic-ui-react";

class Tag extends Component {
  state = {
    isEditing: false,
    name: this.props.name
  };

  inputRef = createRef();

  handleChangeName = (event, { value }) => {
    this.setState({ name: value });
  };

  handleSubmitName = () => {
    this.props
      .edit(this.state.name)
      .then(() => this.setState({ isEditing: false }));
  };

  handleStartEditingName = () => {
    this.setState({ isEditing: true }, () => {
      this.inputRef.current.focus();
    });
  };

  toggleEditing = event => {
    if (
      !event.relatedTarget ||
      !event.relatedTarget.type === "submit" ||
      !event.relatedTarget.className.includes("save")
    ) {
      this.setState(state => {
        return { ...state, isEditing: !state.isEditing };
      });
    }
  };
  render() {
    const { isEditing } = this.state;
    return (
      <Card fluid style={{ margin: "1rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "1rem 2rem"
          }}
        >
          <div style={{ alignSelf: "center" }}>
            {isEditing ? (
              <Input
                value={this.state.name}
                onChange={this.handleChangeName}
                onBlur={this.toggleEditing}
                ref={this.inputRef}
              />
            ) : (
              <Header as="h3">{this.props.name}</Header>
            )}
          </div>
          <div>
            {isEditing ? (
              <Button
                primary
                loading={this.props.updateLoading}
                onClick={this.handleSubmitName}
                className="save"
              >
                Finish editing
              </Button>
            ) : (
              <Button primary onClick={this.handleStartEditingName}>
                Edit
              </Button>
            )}
            <Button
              negative
              loading={this.props.deleteLoading}
              onClick={this.props.delete}
            >
              Delete
            </Button>
            <Button
              color="orange"
              onClick={this.props.toggleVisibility}
              loading={this.props.updateLoading && !isEditing}
            >
              {this.props.visible ? "Set invisible" : "Set visible"}
            </Button>
          </div>
        </div>
      </Card>
    );
  }
}
export default Tag;



// WEBPACK FOOTER //
// ./src/pages/Tags/Tag.js